module.exports = __webpack_public_path__ + "static/media/gift.06870003.svg";